import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { addSubscription, confirmCheckoutSession } from '../../SubscriptionActions';

import { getHostedPage } from '../../SubscriptionReducer';

import CheckoutOkPage from './CheckoutOkPage';

const mapStateToProps = state => {
  return {
    hostedPage: getHostedPage(state),
  };
};

export const validateSubscription = (store, nextState, replace, callback) => {
  const { state, id, session_id: sessionId } = nextState.location.query || {};

  if (sessionId) {
    store
      .dispatch(confirmCheckoutSession(sessionId, replace))
      .then(() => callback())
      .catch(() => {
        replace({ pathname: '/subscriptions/error' });
        callback();
      });
    return;
  }

  if (state === 'succeeded' && id) {
    store
      .dispatch(addSubscription(null, id, replace))
      .then(() => callback())
      .catch(() => {
        callback();
      });
  } else {
    replace({ pathname: '/subscriptions/error' });
    callback();
  }
};

const CheckoutPageContainer = connect(mapStateToProps)(injectIntl(CheckoutOkPage));

export default CheckoutPageContainer;
